import React from 'react';
import {
  CondensedHeader,
  CondensedMedium,
  Gutter,
  Layout,
  LayoutItem,
  Well,
} from '@axiom/ui';

export const GotMatchesNextBestStep = () => {
  return (
    <Gutter bottom="24px">
      <Well background="high attention" name="got-matches-well">
        <CondensedHeader>
          You've got matches - here's what to do next.
        </CondensedHeader>
        <Gutter bottom="8px" />
        <Gutter horizontal="8px">
          <Layout horizontalGutter="8px">
            <LayoutItem>
              <CondensedMedium>•</CondensedMedium>
            </LayoutItem>
            <LayoutItem>
              <CondensedMedium>
                See talent you like? Pin your favorites and request interviews
                when you’re ready.
              </CondensedMedium>
            </LayoutItem>
          </Layout>
          <Layout horizontalGutter="8px">
            <LayoutItem>
              <CondensedMedium>•</CondensedMedium>
            </LayoutItem>
            <LayoutItem>
              <CondensedMedium>
                Need more options? Refresh these matches, edit your legal needs,
                or explore more Axiom talent on your own.
              </CondensedMedium>
            </LayoutItem>
          </Layout>
        </Gutter>
      </Well>
    </Gutter>
  );
};
